import BScroll from 'better-scroll';
<template>
  <div class="createWrap" v-show="isShowPop">
    <!-- 添加卷 -->
    <div class="createpop" v-show="isShowCreateVo">
      <h3>
        添加卷
        <img src="~img/close.png" alt="" @click="closeVo('isShowCreateVo')" />
      </h3>
      <div class="cmain">
        <label for="cName">名称</label>
        <input
          type="text"
          placeholder="请输入卷名称"
          v-model="voC.name"
          id="cName"
        />
        <br />
        <div class="clearfix">
          <label for="cInfo" class="infolabel fl">内容简介</label>
          <textarea
            id="CInfo fl"
            v-model="voC.introduce"
            placeholder="请输入内容简介"
          ></textarea>
        </div>
      </div>
      <el-button class="aubtn" @click="addVo" size="medium">确认</el-button>
    </div>
    <!-- 完本 -->
    <div class="createpop small" v-show="isShowEnd">
      <h3>
        申请完本
        <img src="~img/close.png" alt="" @click="closeVo('isShowEnd')" />
      </h3>
      <div :class="{cmain: true, finishTxt: finishStatus.code == 0}" v-if="finishStatus">
        <div v-if="finishStatus.code == 0">确定要申请完本？ <div class="mainhint">*字数要达到50000字以上才可申请哦~</div></div>
        <p v-else>申请状态：{{finishStatus.desc}}；{{finishStatus.code==-2?"是否要重新申请？":""}}</p>
        <el-button class="aubtn" id="endbtn" size="medium" @click="finishbook"
          >确定</el-button
        >
      </div>
    </div>
    <!-- 公开 -->
    <div class="createpop small" v-show="isShowOpen">
      <h3>
        申请公开
        <img src="~img/close.png" alt="" @click="closeVo('isShowOpen')" />
      </h3>
      <div :class="{cmain: true, finishTxt: openStatus.code == 0}" v-if="openStatus">
        <div v-if="openStatus.code == 0">确定要申请公开？ <div class="mainhint">*字数要达到30000字以上才可申请哦~</div></div>
        <p v-else>申请状态：{{openStatus.desc}}；{{openStatus.code==-2?"是否要重新申请？":""}}</p>
        <el-button class="aubtn" id="endbtn" size="medium" @click="openbook"
          >确定</el-button
        >
      </div>
    </div>
    <!-- 发布 -->
    <div
      :class="{ createpop: true, publishpop: true, pubHeight: radioVal == 1 }"
      v-show="isShowPublish"
    >
      <h3>
        《{{ bookname }}》
        <img src="~img/close.png" alt="" @click="closeVo('isShowPublish')" />
      </h3>
      <p class="title">
        {{ mainInfo.chapterTitle }}
      </p>
      <div class="cmain">
        <div class="chooseitem">
          <label>章节位置</label>
          <el-select v-model="mainInfo.rollvalue" placeholder="请选择">
            <el-option
              v-for="item in mainInfo.volumelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="chooseitem">
          <label>章节类型</label>
          <el-select v-model="mainInfo.chapterType" placeholder="请选择">
            <el-option
              v-for="item in mainInfo.typelist"
              :key="item.value"
              :label="item.desc"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <label for="pWord" style="margin-top:3px">本章字数</label>
        <input
          type="text"
          placeholder="字数"
          v-model="mainInfo.mainCount"
          id="pWord"
          readonly
          style="border:none"
        />
        <el-radio-group v-model="radioVal">
          <el-radio :label="0" @click="changeradio">立即发布</el-radio>
          <el-radio :label="1" @click="changeradio">定时发布</el-radio>
        </el-radio-group>
        <div class="timebox clearfix" v-show="radioVal == 1">
          <el-date-picker
            style="margin-right:8px"
            v-model="dateval"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-time-picker
            v-model="timeval"
            value-format="HH:mm:ss"
            placeholder="任意时间点"
          >
          </el-time-picker>
        </div>
      </div>
      <el-button class="aubtn" @click="publishChapter" size="medium"
        >确认</el-button
      >
    </div>
  </div>
</template>
<script>
import { addVolume } from "apiurl/author";
import { getAbookid } from "utils/storage";
export default {
  props: {
    isShowPop: Boolean, // 控制总体
    finishStatus: Object,
    openStatus: Object,
    isShowCreateVo: Boolean, // 控制添加卷
    isShowEnd: Boolean, //控制申请完本
    isShowPublish: Boolean,
    isShowOpen: {
        type: Boolean,
        default: false
    },
    rollList: Array,
    rollvalue: String,
    TypeList: {
      type: Array,
      default: function() {
        return [{ value: "免费章节", id: 0 }, { value: "付费章节", id: 1 }];
      }
    },
    mainInfo: {
      type: Object,
      default: function() {
        return {
          mainCount: 0, // 字数
          mainCon: "", // 正文
          chapterTitle: "", //章节标题
          authorCon: "", //作者的话,
          volumelist: [],
          typelist: [],
          chapterType: "1",
          rollvalue: "0",
          isSavebtn: true,
          isPubtn: true
        };
      }
    },
    chapterType: Number,
    radio: Number,
    bookname: String
  },
  data() {
    return {
      radioVal: 0,
      dateval: "",
      timeval: "",
      voC: {
        name: "",
        introduce: ""
      }
    };
  },
  methods: {
    // 关闭添加卷
    closeVo(ischoose) {
      this.$emit("changeobj", {
        isShowPop: false,
        [ischoose]: false
      });
    },
    changeradio() {
      this.$emit("changeradio", this.radioVal);
    },
    // 新建卷
    async addVo() {
      if (this.voC.name.replace(/\s*/g, "") !== "") {
        let res = await addVolume({
          bookId: getAbookid(),
          name: this.voC.name,
          introduce: this.voC.introduce
        });
        if (res.success) {
          this.$emit("isSuVo", res);
          this.voC.name = "";
          this.voC.introduce = "";
        }
      } else {
        this.$message.error("分卷名不能为空");
      }
    },
    // 触发发布章节
    publishChapter() {
      let data = "";
      if (this.radioVal == 1) {
        data = `${this.dateval} ${this.timeval}`;
      }
      this.$emit("publishChapter", data);
    },
    openbook(){
        this.$emit("openBook");
    },
    finishbook() {
      this.$emit("finishbook");
    }
  }
};
</script>
<style>
.aubtn.el-button {
  width: 124px;
  height: 34px;
  color: #fff;
  background: #48a2df;
  line-height: 15px;
}
.aubtn.el-button span {
  vertical-align: top;
}
.aubtn.el-button:focus {
  width: 124px;
  height: 34px;
  background: #48a2df;
  border-radius: 4px;
  border-color: #48a2df;
  color: #fff;
  height: 34px;
}
.aubtn.el-button:hover {
  width: 124px;
  height: 34px;
  background: #48a2df;
  border-radius: 4px;
  border-color: #48a2df;
  color: #fff;
  height: 34px;
}
.publishpop .timebox .el-input--suffix .el-input__inner {
  width: 144px;
  height: 34px;
}
.timebox .el-input {
  width: 144px;
}
.publishpop .el-input--suffix .el-input__inner {
  width: 295px;
  height: 34px;
}
.publishpop .el-input--suffix .el-input__icon {
  line-height: 34px;
}
.publishpop .el-input__inner {
  border-radius: 0px;
  border: 1px solid rgba(211, 211, 211, 1);
}
.el-radio__input.is-checked .el-radio__inner {
  background: #48a2df;
  border-color: #48a2df;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #48a2df;
}
.el-radio-group {
  margin-left: 80px;
  margin-bottom: 20px;
}
</style>
<style lang="stylus" scoped>
.createWrap
    position fixed
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.5)
    top 0px
    left 0px
    .createpop
        width 460px
        height 390px
        background rgba(255, 255, 255, 1)
        border-radius 8px
        position absolute
        left 0px
        right 0px
        top 0px
        bottom 0px
        margin auto
        &.small
            width 350px
            height 250px
        &.pubHeight
            height 464px
        &.publishpop
            h3
                color #888
            .title
                font-size 18px
                color rgba(51, 51, 51, 1)
                text-align center
            .timebox
                margin-left 80px
        h3
            background #fff
            text-align center
            border-radius 8px
            img
                width 12px
                height 12px
                position absolute
                right 21px
                top 21px
        .cmain
            padding 20px 38px
            color rgba(51, 51, 51, 1)
            &.finishTxt
                font-size 16px
                margin-top 15px
                font-weight 500
            .mainhint
                font-size: 10px;
                font-family: PingFangSC;
                font-weight: 400;
                color: #f00;
                line-height: 17px;
                padding: 15px 0;
            .chooseitem
                margin-bottom 24px
            p
                padding 40px 0px
                text-align-last center
            label
                width 80px
                display inline-block
                height 34px
                line-height 34px
            input
                width 295px
                height 34px
                background rgba(255, 255, 255, 1)
                box-sizing border-box
                border 1px solid rgba(211, 211, 211, 1)
                padding-left 5px
                margin-bottom 24px
            textarea
                width 295px
                height 180px
                padding-left 5px
                box-sizing border-box
                border 1px solid rgba(211, 211, 211, 1)
                resize none
        .aubtn
            position absolute
            bottom 30px
            right 0
            left 0
            margin 0 auto
</style>
